module.exports = __webpack_public_path__ + "img/form_bg.01ae442e.png";